import React, {useEffect, useState} from 'react';
import {makeApiCall} from "../../../Api/makeApiCall";
import ReactTable from "../../Components/ReactTable";
import Page from "../../Components/Page";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import RetailerIdAndName from "../../Components/RetailerIdAndName";
import {getRetailerName} from "../../../utils/localCache/retailerMapCache";
import _ from "lodash";
import {getDollarsFormat} from "../StoreTotals/Components/SummaryDisplayFunctions";
import {sortAscendingWithNullsFirst} from "../../../utils/sorting";
import {getDateAndDayHeader} from "../Components/getDateAndDayHeader";
import cleanseIcon from "../../../assets/cleanse.png";
import {faIcons} from "../../../utils/iconConstants";
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";
import {cleanseFillExtractTablesQuery} from "../../Spotlight/ExtractSpotlight/ExtractSpotlightPage";
import {currentPeriodQuery} from "../../../queries/currentPeriodQuery";
import moment from "moment";
import classnames from "classnames";
import IconImage, {Icons} from "../../Components/IconImage";
import Modal from "react-modal";
import {Breadcrumbs} from "../../Components/Breadcrumbs";


const SalesByMarketTag = () => {

    const today = moment(Date.now()).format('yyyy-MM-DD');

    const [marketTagOptions, setMarketTagOptions] = useState([]);
    const [cleanseFillExtractTablesOptions, setCleanseFillExtractTablesOptions] = useState([]);
    const [periodOptions, setPeriodOptions] = useState([]);
    const [advancedPeriodOptions, setAdvancedPeriodOptions] = useState([]);

    const [optionsLoading, setOptionsLoading] = useState(true);
    const [dataLoading, setDataLoading] = useState(true);
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);


    const [selectedMarketTag, setSelectedMarketTag] = useState(undefined);
    const [cleanseFillExtractTable, setCleanseFillExtractTable] = useState(undefined);
    const [selectedPeriod, setSelectedPeriod] = useState(undefined);
    const [startWeekId, setStartWeekId] = useState(undefined);
    const [endWeekId, setEndWeekId] = useState(undefined);


    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState([]);
    const [weekEndDates, setWeekEndDates] = useState([]);

    useEffect(() => {
        setOptionsLoading(true)
        Promise.all([
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/marketsTwo/`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/safetyDate`),
            makeApolloClientCall(cleanseFillExtractTablesQuery),
            makeApolloClientCall(currentPeriodQuery),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/timeService`),
            makeApolloClientCall(`{ periods(periodEndWeeksOnly: true) { firstWeekOfPeriod { endDate weekId } endDate periodAbbreviation weekId quadId} }`)
        ])
            .then(([
                       marketsServiceTwo,
                       safetyDateResults,
                       cleanseFillExtractTables,
                       currentPeriodResults,
                       timeServiceResults,
                       periodListResults
                   ]) => {
                const safetyDate = safetyDateResults.safetyDate;

                const marketOptionsWithTags = marketsServiceTwo?.data.map((market) => ({
                    value: market.marketTag,
                    label: `${market.marketTag} - ${market.description}`
                }));

                const cleanseFillExtractValues = cleanseFillExtractTables.tablesInSchema.map(
                    (s) => s.tableName
                ).filter(
                    tableName => tableName.includes('_final')
                ).filter(
                    tableName => tableName.endsWith('_cleanse_fill_extract')
                ).sort((runIdentifier1, runIdentifier2) => {
                    const aTimestamp = runIdentifier1.match(/\d{4}_\d{2}_\d{2}t[\d_]+/)?.[0] ?? '';
                    const bTimestamp = runIdentifier2.match(/\d{4}_\d{2}_\d{2}t[\d_]+/)?.[0] ?? '';
                    return bTimestamp.localeCompare(aTimestamp)
                }).map(tableName => ({value: tableName, label: tableName.replaceAll('_cleanse_fill_extract', '')}));

                const firstCleanseFillExtractValue = _.head(cleanseFillExtractValues);

                const filteredMappedPeriods = periodListResults.periods
                    .filter(period => period.firstWeekOfPeriod.endDate <= today && period.firstWeekOfPeriod.endDate >= safetyDate)
                    .map(period => ({
                        value: period.periodAbbreviation,
                        label: period.periodAbbreviation,
                        startWeekId: period.firstWeekOfPeriod.weekId,
                        endWeekId: period.weekId,
                        endDate: period.endDate,
                        quadId: period.quadId
                    }));

                const maxDateForTimeService = _.maxBy(filteredMappedPeriods, 'endDate')
                const filteredMappedWeeks = timeServiceResults.data
                    .filter(week => week.endDate <= maxDateForTimeService.endDate && week.endDate >= safetyDate)
                    .map(week => ({value: week.periodWeek, label: week.periodWeek}));

                const periodAbbreviation1 = selectedPeriod ? selectedPeriod : currentPeriodResults.records[0]?.periodAbbreviation;
                const currentPeriodDetails = filteredMappedPeriods.find(period => period.value === periodAbbreviation1);

                setMarketTagOptions(marketOptionsWithTags);
                setPeriodOptions(filteredMappedPeriods);
                setCleanseFillExtractTablesOptions(cleanseFillExtractValues);
                setCleanseFillExtractTable(firstCleanseFillExtractValue?.value);
                setSelectedPeriod(currentPeriodDetails.value);
                setAdvancedPeriodOptions(filteredMappedWeeks)
                setStartWeekId(currentPeriodDetails.startWeekId);
                setEndWeekId(currentPeriodDetails.endWeekId);
            }).catch(() => setError(true))
            .finally(() => setOptionsLoading(false));
    }, []);


    const handleSubmit = () => {
        setDataLoading(true);
        setSubmitted(true);
        setShowAdvancedOptions(false);
        makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/salesByMarketTag/?market_tag=${selectedMarketTag}&cleanse_fill_extract_table=${cleanseFillExtractTable}&start_week_id=${startWeekId}&end_week_id=${endWeekId}`)
            .then((salesByMarketTag) => {
                setData(salesByMarketTag.data.stores);
                setWeekEndDates(salesByMarketTag.data.weekEndDates);
            }).finally(() => setDataLoading(false));
    }

    const marketTagOnChange = (option) => {
        setSelectedMarketTag(option.value);
        setSubmitted(false);
    }

    const getSalesByMarketTagColumns = (data, weekEndDates) => {
        const stickyColumns = [
            {
                header: "Market",
                sticky: "left",
                headerStyle: {flex: '2 0 auto'},
                columns: [
                    {
                        header: "Retailer",
                        id: "retailerIdName",
                        accessorKey: "retailerId",
                        sticky: "left",
                        size: 250,
                        cell: ({row}) => <RetailerIdAndName retailerId={row.original.retailerId}/>,
                        filterFn: (row, columnIds, filterValue) => !filterValue || Boolean(`${row.original.retailerId} - ${getRetailerName(row.original.retailerId)?.toLowerCase()}`.includes(filterValue.toLowerCase()))
                    },
                    {
                        header: "Store",
                        id: "storeIdName",
                        accessorKey: "spinsStoreId",
                        sticky: 'left',
                        size: 350,
                        cell: ({row}) => <span>{row.original.spinsStoreId} - {row.original.storeName}</span>,
                        filterFn: (row, columnIds, filterValue) => !filterValue || Boolean(`${row.original.spinsStoreId} - ${row.original.storeName?.toLowerCase()}`.includes(filterValue.toLowerCase())),
                        footer: <span>Totals:</span>
                    }
                ]
            }
        ]

        const columnDates = weekEndDates.sort().reverse();

        const dateGroup = [
            {
                header: "",
                id: 'dates',
                headerStyle: {flex: `${columnDates.length} 0 auto`},
                columns: columnDates.map((date) => {
                    return {
                        id: date,
                        footer: (row) => {
                            const maybeData = data
                                .flatMap(store => store.weekEndData)
                                .filter(weekEndData => (weekEndData.weekEndDate === row.column.id))
                                .map(weekEndData => weekEndData.dollars);
                            return maybeData ? <span>{getDollarsFormat(_.sum(maybeData))}</span> : <span/>;
                        },
                        header: getDateAndDayHeader(date),
                        size: 120,
                        accessorFn: (row) => {
                            const {source, dollars} = row.weekEndData
                                .find(({weekEndDate}) => weekEndDate === date) || {};

                            if (source === 'cleansed') {
                                return {
                                    component: <div className="total-dollar-week-end-date">
                                        <img alt={'cleanse'} className={'cleanse-icon icon-spacing'} src={cleanseIcon}/>
                                        <span id={'cleansed'}>{getDollarsFormat(dollars)}</span>
                                    </div>
                                }
                            } else if (source === 'fill') {
                                return {
                                    component: <div className="total-dollar-week-end-date">
                                        <div id={'has-fill-icon'} className={`${faIcons.fillDrip} icon-spacing`}
                                             data-testid={'has-fill-icon'}/>
                                        <span id={'fill'}>{getDollarsFormat(dollars)}</span>
                                    </div>
                                }
                            } else {
                                return {
                                    component: <div></div>
                                };
                            }


                        },
                        cell: ({getValue}) => getValue().component,
                        enableColumnFilter: false,
                        enableSorting: true,
                        className: "no-padding",
                        sortingFn: (rowA, rowB, columnId) => {
                            const classNameA = rowA.getValue(columnId).className;
                            const classNameB = rowB.getValue(columnId).className;
                            const primarySort = sortAscendingWithNullsFirst(classNameA.match(/\d/g), classNameB.match(/\d/g));
                            if (primarySort !== 0) {
                                return primarySort;
                            }

                            return rowB.index - rowA.index;
                        }
                    };
                })
            }
        ];

        return stickyColumns.concat(dateGroup);
    }

    const canSubmit = () => {
        const hasRequiredValues = optionsLoading !== true && selectedMarketTag !== undefined && cleanseFillExtractTable !== undefined && startWeekId !== undefined && endWeekId !== undefined;
        const startWeekNotGreaterThanEndWeek = startWeekId <= endWeekId;
        return hasRequiredValues && startWeekNotGreaterThanEndWeek;
    }

    return <Page name={"Sales By Market Tag"} beta={true}
                 breadCrumbs={<Breadcrumbs items={[{label: "Retailer Readiness"}, {label: "Sales By Market Tag"}]}/>}>
        <div className={'sales-by-market-search-options-container'}>
            <div className={'sales-by-market-base-search-options'}>
                <div className={'sales-by-market-basic-options-market-tag-wrapper'}
                     data-testid={'sales-by-market-basic-options-market-tag-wrapper'}>
                    <SelectDropdown id={'market_tag_base_search_dropdown'}
                                    dataTestId={'market_tag_base_search_dropdown'}
                                    inputLabel={'Market Tag'}
                                    options={marketTagOptions}
                                    onChange={marketTagOnChange}
                                    selectValue={selectedMarketTag}
                                    selectLabel={marketTagOptions?.find(option => option.value === selectedMarketTag)?.label}
                    />
                </div>
                <div className={'sales-by-market-basic-options-cleanse-fill-extract-wrapper'}
                     data-testid={'sales-by-market-basic-options-cleanse-fill-extract-wrapper'}>
                    <SelectDropdown id={'cleanse_fill_extract_table_base_search_dropdown'}
                                    dataTestId={'cleanse_fill_extract_table_base_search_dropdown'}
                                    inputLabel={'Cleanse Fill Extract'}
                                    options={cleanseFillExtractTablesOptions}
                                    onChange={(option) => setCleanseFillExtractTable(option.value)}
                                    selectValue={cleanseFillExtractTable}
                                    selectLabel={cleanseFillExtractTablesOptions?.find(option => option.value === cleanseFillExtractTable)?.label}
                    />
                </div>
                <div className={'sales-by-market-basic-options-period-wrapper'}
                     data-testid={'sales-by-market-basic-options-period-wrapper'}>
                    <SelectDropdown id={'period_base_search_dropdown'}
                                    dataTestId={'period_base_search_dropdown'}
                                    inputLabel={'Period'}
                                    options={periodOptions}
                                    onChange={(option) => {
                                        setSelectedPeriod(option.value);
                                        setStartWeekId(option.startWeekId);
                                        setEndWeekId(option.endWeekId);
                                    }}
                                    selectValue={selectedPeriod}
                                    selectLabel={periodOptions?.find(option => option.value === selectedPeriod)?.label}
                    />
                </div>
                <div className={"sales-by-market-divider"}/>
                <button type="button"
                        data-testid={'sales-by-market-advanced-options-submit-button'}
                        className={classnames("button", "primary", "sales-by-market-advanced-options")}
                        onClick={() => handleSubmit()}
                        disabled={!canSubmit()}
                >
                    {"Submit"}
                </button>
                <button className={'button sales-by-market-advanced-options sales-by-market-advanced-options-button'}
                        data-testid={'sales-by-market-advanced-options-modal-button'}
                        onClick={() => setShowAdvancedOptions(true)}
                >
                    {!optionsLoading ?
                        <IconImage iconType={Icons.ADVANCED_OPTIONS} className={'advanced-options-icon'}/> :
                        <div className={'sales-by-market-loading'}><i
                            className={`${faIcons.carrot} fa-spin spinner`}/> Loading
                        </div>}
                </button>
            </div>

        </div>
        {showAdvancedOptions === true && <Modal clickable
                                                isOpen={showAdvancedOptions}
                                                className={'Modal totals-modal sales-by-market-advanced-options-container'}
                                                overlayClassName="Overlay"
                                                ariaHideApp={false}
                                                onRequestClose={() => setShowAdvancedOptions(false)}
                                                testId={"sales-by-market-advanced-options-modal"}>
            <div className={'sales-by-market-search-options-container'}>
                <div className={'sales-by-market-advanced-options-modal-header'}
                     data-testid={'confirmation-modal-header'}>
                    <h5>Advanced Options</h5>
                    <div className={'modal-exit-button'} data-testid={'confirmation-modal-exit-button'}>
                        <button className={"right-exit-button"}
                                onClick={() => setShowAdvancedOptions(false)}
                                disabled={optionsLoading}
                        >
                            <i data-testid={'x-icon'} className={faIcons.xClose}/></button>
                    </div>
                </div>
                <hr className={"draw-a-line"}/>
                <div className={'sales-by-market-advanced-options-container'}>
                    <div className={'sales-by-market-advanced-options-basic-options-wrapper'}>
                        <h6>Basic Options</h6>
                        <div className={'sales-by-market-advanced-options-basic-options-row'}>
                            <div className={'sales-by-market-advanced-options-market-tag-wrapper'}
                                 data-testid={'sales-by-market-advanced-options-market-tag-wrapper'}>
                                <label id={'market_tag_label'} data-testid={'label-market-tag'}>Market Tag</label>
                                <SelectDropdown id={'market_tag_advanced_search_dropdown'}
                                                options={marketTagOptions}
                                                onChange={marketTagOnChange}
                                                selectValue={selectedMarketTag}
                                                selectLabel={marketTagOptions?.find(option => option.value === selectedMarketTag)?.label}
                                />
                            </div>
                            <div className={'sales-by-market-advanced-options-cleanse-fill-extract-wrapper'}
                                 data-testid={'sales-by-market-advanced-options-cleanse-fill-extract-wrapper'}>
                                <label id={'cleanse_fill_extract_label'} data-testid={'label-market-tag'}>Cleanse Fill
                                    Extract</label>
                                <SelectDropdown id={'cleanse_fill_extract_table_advanced_search_dropdown'}
                                                dataTestId={'cleanse_fill_extract_table_advanced_search_dropdown'}
                                                options={cleanseFillExtractTablesOptions}
                                                onChange={(option) => setCleanseFillExtractTable(option.value)}
                                                selectValue={cleanseFillExtractTable}
                                                selectLabel={cleanseFillExtractTablesOptions?.find(option => option.value === cleanseFillExtractTable)?.label}
                                />
                            </div>
                        </div>
                        <div className={'sales-by-market-advanced-options-basic-options-row'}>
                            <div className={'sales-by-market-advanced-options-period-wrapper'}
                                 data-testid={'sales-by-market-advanced-options-period-wrapper'}>
                                <label id={'period_label'} data-testid={'label-market-tag'}>Select Period</label>
                                <SelectDropdown id={'period_advanced_search_dropdown'}
                                                dataTestId={'period_advanced_search_dropdown'}
                                                options={periodOptions}
                                                onChange={(option) => {
                                                    setSelectedPeriod(option.value);
                                                    setStartWeekId(option.startWeekId);
                                                    setEndWeekId(option.endWeekId);
                                                }}
                                                selectValue={selectedPeriod}
                                                selectLabel={periodOptions?.find(option => option.value === selectedPeriod)?.label}
                                />
                            </div>
                        </div>
                    </div>
                    <hr className={"draw-a-line"}/>
                    <div className={'sales-by-market-advanced-options-additional-advanced-advanced-options-wrapper'}>
                        <h6>Advanced Filters</h6>
                        <div className={'sales-by-market-advanced-options-additional-advanced-advanced-options-row'}>
                            <div className={'sales-by-market-advanced-filters-start-period-wrapper'}
                                 data-testid={'sales-by-market-advanced-filters-start-period-wrapper'}>
                                <label id={'start_period_dropdown_label'}>Start Period</label>
                                <SelectDropdown id={'start_period_dropdown'}
                                                dataTestId={"start_period_dropdown"}
                                                options={advancedPeriodOptions}
                                                onChange={(option) => setStartWeekId(option.value)}
                                                selectValue={startWeekId}
                                                selectLabel={advancedPeriodOptions?.find(option => option.value === startWeekId)?.label}
                                />
                            </div>
                            <div className={'sales-by-market-advanced-filters-end-period-wrapper'}
                                 data-testid={'sales-by-market-advanced-filters-end-period-wrapper'}>
                                <label id={'start_period_dropdown_label'}>End Period</label>
                                <SelectDropdown id={'end_period_dropdown'}
                                                dataTestId={"end_period_dropdown"}
                                                options={advancedPeriodOptions}
                                                onChange={(option) => setEndWeekId(option.value)}
                                                selectValue={endWeekId}
                                                selectLabel={advancedPeriodOptions?.find(option => option.value === endWeekId)?.label}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"right-things"}>
                    <button className="button modal-button cancel" type="button" name="close"
                            onClick={() => setShowAdvancedOptions(false)}>
                        Cancel
                    </button>
                    <button type="button"
                            className={classnames("button", "modal-button", "confirm")}
                            data-testid={'sales-by-market-advanced-options-modal-submit-button'}
                            onClick={() => handleSubmit()}
                            disabled={!canSubmit()}
                    >
                        {"Submit"}
                    </button>
                </div>
            </div>
        </Modal>}
        {error &&
            <div className={'error-message'} data-testid={'error-message'}>There was an error loading the data.
                Please try again later.</div>}
        {submitted && <LoadingWrapper loading={dataLoading}>
            <ReactTable filterable={true}
                        columns={getSalesByMarketTagColumns(data, weekEndDates)}
                        data={data}
                        initialState={{
                            sorting: [{id: 'retailerIdName', desc: true}, {id: 'storeIdName', desc: true}],
                            pagination: {pageSize: 10}
                        }}
                        hasStickyHeader={true}
            />
        </LoadingWrapper>}
    </Page>
};

export default SalesByMarketTag;